function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from "react";
import MaskedInput from 'react-text-mask';
import Input from "@hig/input";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Checkmark16 } from "@hig/icons";

const MaskInput = ({
  showLoadingSpinner,
  value,
  className,
  onChange,
  id,
  showCheckmark,
  // showCheckmark when process is done. 
  mask,
  // eslint-disable-next-line no-unused-vars
  showError
}) => {
  const [currentVal, setCurrentVal] = useState(null);

  const handleChange = e => {
    e.preventDefault();
    /* 
      If you need to access event object’s properties after the event handler has run, 
      you need to call e.persist():
    */

    e.persist();
    setCurrentVal(e);
    onChange(e);
  };

  const onKeyDown = e => {
    if (e.key === 'Enter') {
      onChange(currentVal);
    }
  };

  const handleFocus = ele => {
    document.querySelector('#contract-number-input').addEventListener('click', e => {
      if (currentVal && currentVal.target) {
        const cleanValue = currentVal.target.value.replace(/[^\d]/g, '');
        e.target.setSelectionRange(cleanValue.length, cleanValue.length);
      } else {
        e.target.setSelectionRange(0, 0);
      }
    });
    ele.preventDefault();
  };

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(MaskedInput, {
    mask: mask,
    showMask: true,
    guide: true,
    keepCharPositions: true,
    onChange: handleChange,
    id: "contract-number-input",
    onFocus: handleFocus,
    onBlur: e => e.preventDefault(),
    render: (ref, props) => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InnerInput, _extends({
        variant: "box",
        inputRef: ref,
        autoComplete: "off",
        value: value,
        id: id,
        onMouseEnter: e => e.preventDefault(e),
        onMouseLeave: e => e.preventDefault(e),
        onKeyDown: onKeyDown,
        className: showLoadingSpinner ? 'spinner' : className
      }, props)), /*#__PURE__*/React.createElement("div", null, showCheckmark && /*#__PURE__*/React.createElement(CheckMarkDiv, {
        className: "testing"
      }, /*#__PURE__*/React.createElement(Checkmark16, {
        color: "green",
        style: {
          transform: 'translateY(-26px)',
          marginLeft: 'calc(100% - 30px)'
        }
      }))));
    }
  }));
};

MaskInput.propTypes = {
  showLoadingSpinner: PropTypes.bool,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  id: PropTypes.string,
  isError: PropTypes.bool,
  showCheckmark: PropTypes.bool,
  mask: PropTypes.array
};
const CheckMarkDiv = styled.div`
  height: 0px;
`;
const InnerInput = styled(Input)`
  .spinner__halo {
    top: 45px;
    // Conversion of rgba(255, 255, 255, 0.75) to hsla through sass
    // was causing errors in built package. Blue intentionally set to 254
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    height: 25px;
    left: 101%;
    margin: -40px 0 0 -40px;
    width: 25px;
    background-color: rgba(255, 255, 254, 0.75);
    background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdmctbG9hZGVyLXJpbmctcGFydGlhbCIgdmlld0JveD0iMCAwIDc5LjggNzkuOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48c3R5bGU+LmNlc3Qwe29wYWNpdHk6LjE1O2VuYWJsZS1iYWNrZ3JvdW5kOm5ld30uY2VzdDAsLmNlc3Qxe2ZpbGw6IzY2Nn08L3N0eWxlPgogICAgPHBhdGggaWQ9ImNlU3VidHJhY3Rpb25fMl8xXyIgY2xhc3M9ImNlc3QwIiBkPSJNMzkuOSA3OS44QzE3LjggNzkuOCAwIDYxLjkgMCAzOS45IDAgMTcuOCAxNy45IDAgMzkuOSAwczM5LjkgMTcuOSAzOS45IDM5LjljMCAxNi05LjYgMzAuNS0yNC40IDM2LjctNC45IDIuMS0xMC4yIDMuMi0xNS41IDMuMnptMC03NkMyMCAzLjggNCAxOS45IDQgMzkuN2MwIDE5LjggMTYuMSAzNS45IDM1LjkgMzUuOHMzNS45LTE2LjEgMzUuOC0zNS45YzAtMTQuNC04LjYtMjcuNC0yMS45LTMzLTQuNC0xLjgtOS4xLTIuOC0xMy45LTIuOHoiLz4KICAgIDxwYXRoIGlkPSJjZVN1YnRyYWN0aW9uXzNfMV8iIGNsYXNzPSJjZXN0MSIgZD0iTTc5LjkgMzkuOGgtNGMwLTE5LjktMTYuMS0zNi0zNS45LTM2aC0uMXYtNGMyMiAwIDM5LjkgMTcuOSA0MCA0MHoiLz4KPC9zdmc+);
    -webkit-animation-name: spin;
    -webkit-animation-duration: 1ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
    -moz-animation-name: spin;
    -moz-animation-duration: 1ms;
    -moz-animation-iteration-count: infinite;
    -moz-animation-timing-function: linear;
    -ms-animation-name: spin;
    -ms-animation-duration: 1ms;
    -ms-animation-iteration-count: infinite;
    -ms-animation-timing-function: linear;
    
    animation-name: spin;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @-ms-keyframes spin {
    from { -ms-transform: rotate(0deg); }
    to { -ms-transform: rotate(360deg); }
  }
  @-moz-keyframes spin {
    from { -moz-transform: rotate(0deg); }
    to { -moz-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    from { -webkit-transform: rotate(0deg); }
    to { -webkit-transform: rotate(360deg); }
  }
  @keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
  }
`;
export default styled(MaskInput)`
  height: 34px;
  overflow: hidden;
  position: relative;
  border-bottom-color: rgba(128,128,128,0.2);

  > input {
    font-weight: 400;
    ${({
  showError
}) => showError && `
      border: 1px solid #ec4a41;
      box-shadow: none;
    `}

    :focus {
      border: 1px solid #0696d7;
      box-shadow: 0 0 5px #0696d7;
    }
  }

  > div {
    height: 0px;
  }
`;